import {IndexedDBCache} from "finhelper";

export default class CacheHelper
{
  static SERVER_DATA = 'server';

  /**
   *
   * @param pattern
   * @param params
   * @return {*}
   */
  static generateKey = (pattern, params) => {
    Object.keys(params).forEach(key => {
      // Replace all occurrences of {param} in the pattern with corresponding values
      pattern = pattern.replace(new RegExp(`{${key}}`, 'g'), params[key]);
    });

    return pattern;
  };

  /**
   *
   */
  static startAgain()
  {
    IndexedDBCache.clearAll();
  }

  /**
   *
   */
  static clearAll()
  {
    localStorage.clear();
    IndexedDBCache.clearAll();
  }

}